import DKplanLogin from "../NIRAS/Login.js";
import News from "../NIRAS/News.js";

window.DKplanLogin = DKplanLogin;
window.News = News;